import React from 'react'
import {
    Button,
} from 'reactstrap'
import {
    uploadFile,
} from '../model/request/files'

class UploadFileViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        this.state = {
            selectedFiles: undefined,
            currentFile: undefined,
            progress: 0,
            message: "",
        }
    }

    selectFile(event) {
        this.setState({
            'selectedFiles': event.target.files,
            'currentFile': undefined,
            'message': '',
            'progress': 0,
        })
    }

    upload() {
        let currentFile = this.state.selectedFiles[0]

        this.setState({
            progress: 0,
            currentFile: currentFile,
        })

        uploadFile(this.props.quoteId, currentFile, (event) => {
            if (event.loaded >= event.total) {
                this.setState({
                    progress: 0,
                    selectedFiles: undefined,
                    currentFile: undefined,
                    message: 'Upload Success',
                })
            } else {
                this.setState({
                    progress: Math.round((100 * event.loaded) / event.total),
                })
            }
        }).then(
            (result) => {
                if (this.props.onUploaded) {
                    this.props.onUploaded()
                }
            },
            (error) => {
                this.props.showError(error)
            }
        ).catch(() => {
            this.setState({
                progress: 0,
                message: "Could not upload the file!",
                currentFile: undefined,
            })
        })

        this.setState({
            selectedFiles: undefined,
        })
    }


    // MARK: Render

    render() {
        const {
            selectedFiles,
            currentFile,
            progress,
            message,
        } = this.state

        return (
            <div>
                {currentFile && (
                    <div className="progress">
                        <div
                            className="progress-bar progress-bar-info progress-bar-striped"
                            role="progressbar"
                            aria-valuenow={progress}
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{ width: progress + "%" }}>
                            {progress}%
                        </div>
                    </div>
                )}

                <label className="btn btn-default">
                    <input type="file" onChange={(e) => this.selectFile(e)} />
                </label>

                <Button color="success"
                    disabled={!selectedFiles}
                    onClick={(e) => this.upload()}
                    > Upload </Button>

                <div className="alert alert-light" role="alert">
                    {message}
                </div>
            </div>
        )
    }
}

export {
    UploadFileViewController,
}

